<template>
  <div class="container">
    <div class="row">
      <h4>Logging Out ...</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'logout',
  mounted: function() {
    // Delete data from state
    this.$store.commit('RESET_STATE')
    this.$http
      .post(this.$base + '/api/v1/rest-auth/logout/', {})
      .then(response => {
        this.$session.remove('site')
        this.$session.remove('user')
        this.$auth.logout()
        this.$router.push('login')
      })
      .catch(err => {
        console.log(err)
        this.$auth.logout()
        this.$router.push('login')
      })
  },
}
</script>
